import type { EditorTextBoxDocument } from '@messenger/lotus'
import { canonicalFontName, extractFontFamiliesFromHtml } from './fontNames'

type ScanItem = {
  type?: string
  id?: string
  text?: { value?: string | null } | null
}
type ScanPage = { product?: { items?: ScanItem[] } | null } | null

const addDocumentFonts = (
  document: EditorTextBoxDocument,
  out: Set<string>,
): void => {
  for (const block of document.resolved.blocks) {
    for (const run of block.runs) {
      if (run.text && run.text.length > 0 && run.style.fontFamily) {
        const canon = canonicalFontName(run.style.fontFamily)
        if (canon) out.add(canon)
      }
    }
  }
}

export const collectUsedFontsFromPages = (
  pages: readonly ScanPage[],
  documents: readonly EditorTextBoxDocument[] = [],
): string[] => {
  const out = new Set<string>()
  for (const page of pages) {
    for (const item of page?.product?.items ?? []) {
      if (item?.type === 'text' && item.text?.value) {
        for (const f of extractFontFamiliesFromHtml(item.text.value)) out.add(f)
      }
    }
  }
  for (const document of documents) addDocumentFonts(document, out)
  return [...out].sort((a, b) => a.localeCompare(b))
}
